import React, { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./App.css";
import BG1 from './assets/BG-1.png';
import BG2 from './assets/BG-2.png';
import BG3 from './assets/BG-3.png';
import BilgiYarismasiLogo from './assets/BilgiYarismasiLogo.png';
import CloseRedButton from './assets/CloseRedButton,.png';
import FalseIcon from './assets/False.png';
import InfoButton from './assets/InfoButton.png';
import LeaderboardButton from './assets/LeaderboardButton.png';
import GoBack from './assets/goBack.png';
import SoundOffButton from './assets/SoundOffButton.png';
import SoundOnButton from './assets/SoundOnButton.png';
import StartButton from './assets/StartButton.png';
import TrueIcon from './assets/True.png';
import ZCoin from './assets/coin.png';
import PoweredByZuzzuu from './assets/poweredByZuzzuu.png';
import BackgroundMusic from './music/CCI_TRIVIA_MUSIC.mp3';
import { ErrorContext } from "./index";

function App() {
  const oyunAcildiEventGitti = React.useRef(false);
  const backgroundMusicRef = React.useRef(null);
  const leaderboardBaseUrl = "https://zuzzuu.com/ldrbrd_cci_ksaMz2dZbLcP5vS3p8JufRmYQeCwHh";
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const [userID, setUserID] = useState('');
  const baseUrl = queryParams.get("baseUrl") || "https://trivia.api.zuzzuu.com";
  const API_REFRESH_TOKEN_ENDPOINT = "https://api.cokecrush.cci.zuzzuu.com/refresh_token/";
  // --- YENİ REKLAM (GameAds) API ---
  // Yeni reklam servisi sabitleri. Prod'a geçişte ADS_API_BASE_URL değiştirilir.
  const ADS_API_BASE_URL = "https://cci.gameads.api.zuzzuu.com/api/v1";
  const AD_GAME_NAME = "cci-bilgi-yarismasi";

  const { errorMessage, setErrorMessage } = useContext(ErrorContext);

  const [screen, setScreen] = useState("lobby");
  const [infoOpen, setInfoOpen] = useState(false);
  const [leaderboardOpen, setLeaderboardOpen] = useState(false);
  const [leaderboardUrl, setLeaderboardUrl] = useState("");
  const [soundOpen, setSoundOpen] = useState(true);
  const [triviaId, setTriviaId] = useState(null);
  const [isChecking, setIsChecking] = useState(false);
  const [isTokenInvalid, setIsTokenInvalid] = useState(false);
  const [accessToken, setAccessToken] = useState(token || "");
  const [sessionId] = useState(() => {
    const existing = localStorage.getItem("trivia_session_id");
    if (existing) return existing;
    const created = generateSessionId();
    localStorage.setItem("trivia_session_id", created);
    return created;
  });
  function goBack() {
    // Yeni token ile gamecenter'a yönlendir
    const currentTokenFromUrl = queryParams.get("token");
    const tokenToUse = accessToken || currentTokenFromUrl;
    if (tokenToUse) {
      window.location.href = `https://cci.gamecenter.zuzzuu.com/?token=${tokenToUse}`;
    } else {
      window.history.back();
    }
  }
  const openLeaderboard = () => {
    if (!accessToken) return;
    setLeaderboardUrl(`${leaderboardBaseUrl}/?user_id=${userID}&token=${accessToken}&game_name=bilgi_yarismasi`);
    setLeaderboardOpen(true);
  };

  async function fetchWithRefresh(url, options, runtime, retry = true) {
    try {
      // Geçersiz token durumunda istek yapma
      if (isTokenInvalid) {
        throw new Error('Geçersiz Token');
      }

      const response = await fetch(url, options);
      // 401 veya 403 hatalarında "Geçersiz Token" mesajı göster (otomatik refresh devre dışı)
      if (response.status === 401 || response.status === 403) {
        setErrorMessage("Geçersiz Token");
        setIsTokenInvalid(true);
        if (response.status === 403) {
          // 403 durumunda 3 sn sonra gamecenter'a yönlendir
          const originalToken = queryParams.get("token");
          setTimeout(() => {
            if (originalToken) {
              window.location.href = `https://cci.gamecenter.zuzzuu.com/?token=${originalToken}`;
            } else {
              window.location.href = `https://cci.gamecenter.zuzzuu.com/?token=`;
            }
          }, 3000);
        }
        throw new Error('Geçersiz Token');
      }
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Yalnızca uygulama açılışında bir kez refresh yap
  const didRunInitialRefreshRef = React.useRef(false);
  const isRefreshingRef = React.useRef(false);
  const [isInitialRefreshDone, setIsInitialRefreshDone] = useState(!token);

  async function refreshAccessToken(runtime) {
    try {
      // Tekilleştirme: Aynı anda/tekrar refresh'i engelle
      if (isRefreshingRef.current) {
        return runtime.globalVars.Token;
      }
      isRefreshingRef.current = true;

      const accessTokenCurrent = runtime.globalVars.Token;
      const url = `${API_REFRESH_TOKEN_ENDPOINT}?access_token=${accessTokenCurrent}`
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Cache-Control": "no-store, no-cache, must-revalidate",
          "Pragma": "no-cache",
        },
        cache: "no-store",
      });

      // 401 veya 403 hatalarında "Geçersiz Token" mesajı göster
      if (response.status === 401 || response.status === 403) {
        setErrorMessage("Geçersiz Token");
        setIsTokenInvalid(true);
        if (response.status === 403) {
          // 403 durumunda 3 sn sonra gamecenter'a yönlendir
          const originalToken = queryParams.get("token");
          setTimeout(() => {
            if (originalToken) {
              window.location.href = `https://cci.gamecenter.zuzzuu.com/?token=${originalToken}`;
            } else {
              window.location.href = `https://cci.gamecenter.zuzzuu.com/?token=`;
            }
          }, 3000);
        }
        throw new Error('Geçersiz Token');
      }

      if (!response.ok) {
        throw new Error('Token refresh is not success.');
      }

      // Yanıt JSON ya da düz metin olabilir; ikisini de destekle
      let newAccessToken = null;
      const contentType = (response.headers.get("content-type") || "").toLowerCase();
      try {
        if (contentType.includes("application/json")) {
          const result = await response.json();
          newAccessToken = result?.access_token || result?.token || (typeof result === 'string' ? result : null);
        } else {
          const text = (await response.text())?.trim();
          if (text) newAccessToken = text.replace(/^"|"$/g, "");
        }
      } catch (e) {
        const text = (await response.text().catch(() => ""))?.trim();
        if (text) newAccessToken = text.replace(/^"|"$/g, "");
      }

      // Eğer yeni token dönmezse hata ver
      if (!newAccessToken) {
        setErrorMessage("Geçersiz Token");
        setIsTokenInvalid(true);
        throw new Error('Geçersiz Token');
      }

      // Yeni access token'ı global değişkenlere ve state'e set et
      runtime.globalVars.Token = newAccessToken;
      setAccessToken(newAccessToken);
      setIsTokenInvalid(false);

      return newAccessToken;

    } catch (error) {
      console.error("Token yenileme sırasında hata:", error);
      throw error;
    } finally {
      isRefreshingRef.current = false;
    }
  }

  function generateSessionId(length = 32) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  }

  // --- YENİ REKLAM EVENT / DEEPLINK YARDIMCILARI ---
  // Reklam gösterimi için benzersiz bir oturum id'si üret (UUID veya fallback).
  function generateAdSessionId() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
    return "s-" + Date.now() + "-" + Math.random().toString(36).slice(2, 10);
  }

  // Platform tespiti — endpoint'e gönderilecek değer (mobile | web)
  function getPlatform() {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    return isMobile ? "mobile" : "web";
  }

  // POST /game-ads/events — Tracking event gönder (impression, skip, view_start, view_complete, click)
  async function sendAdEvent(eventType, ad, sessionId, metadata) {
    try {
      if (!ad?.id) return null;
      const body = {
        ad_id: ad.id,
        event_type: eventType,
      };
      if (sessionId) body.session_id = sessionId;
      if (metadata && Object.keys(metadata).length > 0) body.metadata = metadata;

      const response = await fetchWithRefresh(
        `${ADS_API_BASE_URL}/game-ads/events`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        },
        { globalVars: { Token: accessToken } }
      );
      if (!response || !response.ok) {
        console.warn(`Event gönderimi başarısız (${eventType}):`, response?.status);
        return null;
      }
      return await response.json().catch(() => null);
    } catch (e) {
      console.warn(`Event gönderimi hatası (${eventType}):`, e);
      return null;
    }
  }

  // POST /game-ads/events/click-with-redirect — Click event yaz + uygun deeplink URL'i al
  async function sendClickWithRedirect(ad, sessionId) {
    try {
      if (!ad?.id) return null;
      const body = {
        ad_id: ad.id,
        platform: getPlatform(),
      };
      if (sessionId) body.session_id = sessionId;

      const response = await fetchWithRefresh(
        `${ADS_API_BASE_URL}/game-ads/events/click-with-redirect`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        },
        { globalVars: { Token: accessToken } }
      );
      if (!response || !response.ok) {
        console.warn("Click-with-redirect başarısız:", response?.status);
        return null;
      }
      return await response.json().catch(() => null);
    } catch (e) {
      console.warn("Click-with-redirect hatası:", e);
      return null;
    }
  }

  // Deeplink butonuna tıklandığında: click event yazar, redirect_url varsa yönlendirir.
  async function handleDeeplinkClick(ad, sessionId) {
    if (!ad?.deeplink_enabled) return;
    const result = await sendClickWithRedirect(ad, sessionId);
    if (result && result.redirect_url) {
      const isMobile = getPlatform() === "mobile";
      const linkType = isMobile ? ad.mobile_deeplink_type : ad.web_deeplink_type;
      if (linkType === "internal") {
        window.location.href = result.redirect_url;
      } else {
        window.open(result.redirect_url, "_blank", "noopener,noreferrer");
      }
    }
  }

  useEffect(() => {
    if (!token && !errorMessage) {
      setErrorMessage("Geçersiz oturum");
      // Removed navigation to error page; error state will be shown via context.
    }
  }, [token, errorMessage, setErrorMessage]);

  // App açılır açılmaz refresh token isteği yap (yalnızca bir kez)
  useEffect(() => {
    if (!token || isTokenInvalid) {
      setIsInitialRefreshDone(true);
      return;
    }
    if (didRunInitialRefreshRef.current) return;
    didRunInitialRefreshRef.current = true;

    const refreshTokenOnStart = async () => {
      try {
        const newToken = await refreshAccessToken({ globalVars: { Token: token } });
        console.log("Token başarıyla yenilendi:", newToken);
        // refresh başarılı ise olası önceki hatayı temizle
        setErrorMessage(null);
      } catch (error) {
        console.error("Token yenileme başarısız:", error);
        // Hata zaten refreshAccessToken içinde handle ediliyor
      } finally {
        setIsInitialRefreshDone(true);
      }
    };

    refreshTokenOnStart();
    // deliberately empty deps to run only once in this session
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Lobby açıldığında trivia aktifliği ve token kontrolü (ilk kontrol)
  useEffect(() => {
    if (!token || isTokenInvalid) return;
    if (token && !isInitialRefreshDone) return;
    if (didRunCheckRef.current) return;
    didRunCheckRef.current = true;

    setIsChecking(true);
    fetchWithRefresh(`${baseUrl}/trivia-progress/check`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }, { globalVars: { Token: accessToken } })
      .then(async response => {
        if (!response.ok) {
          const errorData = await response.json();
          let errorMsg = errorData.detail || errorData.message || "Bir hata oluştu";
          setErrorMessage(errorMsg);
          setTriviaId(null);
          return;
        }
        const data = await response.json();
        if (data?.has_active_trivia === true) {
          if (data?.trivia_id) setTriviaId(data.trivia_id); else setTriviaId(null);
          if (data?.user_id) setUserID(data.user_id);
          setErrorMessage(null);
          return;
        }
        setErrorMessage("Aktif trivia bulunamadı");
        setTriviaId(null);
      })
      .catch(() => {
        setErrorMessage("Sunucuya ulaşılamadı");
        setTriviaId(null);
      })
      .finally(() => {
        setIsChecking(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, baseUrl, isInitialRefreshDone, isTokenInvalid, accessToken]);

  // Lobby ilk açıldığında oyun_acildi eventini gönder
  useEffect(() => {
    if (
      token &&
      screen === "lobby" &&
      triviaId &&
      !oyunAcildiEventGitti.current
    ) {
      sendTriviaEvent({
        event_name: "oyun_acildi",
        trivia_id: triviaId,
        token,
        baseUrl,
        session_id: sessionId,
      });
      oyunAcildiEventGitti.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, screen, baseUrl, triviaId, sessionId]);

  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [score, setScore] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [answered, setAnswered] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [timer, setTimer] = useState(0);
  const [loading, setLoading] = useState(true);
  const [timerExpired, setTimerExpired] = useState(false);
  const [correctAnswerId, setCorrectAnswerId] = useState(null);
  const [isCorrectAnswer, setIsCorrectAnswer] = useState(null);
  const [isAnswerLoading, setIsAnswerLoading] = useState(false);
  const [paused, setPaused] = useState(false);
  const didRunCheckRef = React.useRef(false);
  const didRunAdsRef = React.useRef(false);
  const [adsStart, setAdsStart] = useState([]);
  const [adsInGame, setAdsInGame] = useState([]);
  const [adsEnd, setAdsEnd] = useState([]);
  const [currentAd, setCurrentAd] = useState(null);
  const [adModalOpen, setAdModalOpen] = useState(false);
  const [adClosable, setAdClosable] = useState(false);
  const [adMuted, setAdMuted] = useState(true);
  const adVideoRef = React.useRef(null);
  // Reklam oturumu: aynı reklam gösterimi (bir pozisyon turu) boyunca tüm
  // event'lerde (impression/skip/view_complete/click) sabit kalan session_id.
  const adSessionIdRef = React.useRef(null);
  // view_complete event'inin idempotency'si için: aynı reklam için tekrar göndermeyi engelle.
  const adViewCompleteSentRef = React.useRef(false);
  // view_start event'inin idempotency'si için: aynı video reklam için tekrar göndermeyi engelle.
  const adViewStartSentRef = React.useRef(false);
  // Her pozisyon (oyun_basinda / oyun_esnasinda / oyun_sonunda) sayfa oturumu boyunca
  // yalnızca BİR KEZ reklam göstersin. Sayfa yenilenince ref sıfırlanır (yeniden gösterilebilir).
  const adShownPositionsRef = React.useRef({});
  // Bir pozisyon için reklam turunu başlat — sadece o pozisyon daha önce gösterilmediyse.
  const tryShowAd = (adsList, position) => {
    if (!Array.isArray(adsList) || adsList.length === 0) return false;
    if (adShownPositionsRef.current[position]) return false; // bu pozisyon zaten gösterildi
    adShownPositionsRef.current[position] = true;
    showAd(adsList[0], position, 0);
    return true;
  };
  // AD TIMER STATES
  const [adTimer, setAdTimer] = useState(0);
  const [adTotalTime, setAdTotalTime] = useState(0);
  // Reklamın toplam gösterim süresi (özellikle image reklamların otomatik kapanması için).
  const [adShowingTime, setAdShowingTime] = useState(0);
  // Skip butonunun aktifleşeceği süre (skip_button_active_sec); ikili zamanlayıcı için gerekli.
  const [adSkipActiveSec, setAdSkipActiveSec] = useState(0);
  // Forcing rerender for video progress bar (deprecated, replaced with percent state)
  // const [, setVideoProgress] = useState(0);
  // Track percent progress for ad video progress bar
  const [videoProgressPercent, setVideoProgressPercent] = useState(0);
  // Track if we need to fetch next question after ad closes
  const [pendingNextQuestion, setPendingNextQuestion] = useState(false);

  // Update video progress bar as video plays
  useEffect(() => {
    const video = adVideoRef.current;
    if (!video) return;

    const updateProgress = () => {
      if (video && video.duration && !video.paused) {
        setVideoProgressPercent((video.currentTime / video.duration) * 100);
        setAdTimer(Math.floor(video.currentTime));
      }
    };

    video.addEventListener("timeupdate", updateProgress);
    return () => {
      video.removeEventListener("timeupdate", updateProgress);
    };
  }, [currentAd]);

  // Unmute mandatory video ads after 0.1s if allowed
  useEffect(() => {
    const video = adVideoRef.current;
    if (
      video &&
      currentAd?.media_type === "video" &&
      currentAd.mandatory
    ) {
      const timer = setTimeout(() => {
        try {
          video.muted = false;
          video.volume = 1;
          setAdMuted(false);
        } catch (e) {
          // Tarayıcı engellerse sessiz geç
        }
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [currentAd]);

  // Reset video progress percent when a new video ad starts
  useEffect(() => {
    if (currentAd?.media_type === "video") {
      setVideoProgressPercent(0);
    }
  }, [currentAd]);

  // Restart mandatory video ads if paused
  useEffect(() => {
    const video = adVideoRef.current;
    if (!video || currentAd?.media_type !== "video" || !currentAd.mandatory) return;

    const handlePause = () => {
      if (!video.ended) {
        video.play().catch(() => { });
      }
    };

    video.addEventListener("pause", handlePause);
    return () => {
      video.removeEventListener("pause", handlePause);
    };
  }, [currentAd]);



  useEffect(() => {
    // İlk açılışta 3 pozisyonda reklamları çek
    if (!token || isTokenInvalid) return;
    if (token && !isInitialRefreshDone) return;

    // Kalıcı oturum kilidi: aynı oturumda sadece bir kez çalıştır
    const adsLockKey = 'cci_trivia_ads_done';
    if (sessionStorage.getItem(adsLockKey) === '1') return;
    if (didRunAdsRef.current) return;
    didRunAdsRef.current = true;
    sessionStorage.setItem(adsLockKey, '1');

    const fetchAds = async (position, setter, current) => {
      try {
        const res = await fetchWithRefresh(
          `${ADS_API_BASE_URL}/game-ads/${AD_GAME_NAME}?position=${position}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          },
          { globalVars: { Token: accessToken } }
        );
        const data = await res.json();
        // Yeni API doğrudan array döner; eski format (data.ads) ile geriye dönük uyum.
        const rawList = Array.isArray(data) ? data : (data?.ads || []);
        // Sıralama: video reklamlar önce, image'lar sonra (yeni script davranışı).
        const list = [...rawList].sort((a, b) => {
          const at = a.media_type || "video";
          const bt = b.media_type || "video";
          if (at === "video" && bt === "image") return -1;
          if (at === "image" && bt === "video") return 1;
          return 0;
        });
        // Redundant state güncellemeyi önle
        if (!Array.isArray(current) || current.length !== list.length) {
          setter(list);
        }
      } catch {
        if (Array.isArray(current) && current.length === 0) return;
        setter([]);
      }
    };
    fetchAds("oyun_basinda", setAdsStart, adsStart);
    fetchAds("oyun_esnasinda", setAdsInGame, adsInGame);
    fetchAds("oyun_sonunda", setAdsEnd, adsEnd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, isInitialRefreshDone, isTokenInvalid, accessToken]);


  const showAd = (ad, position, index) => {
    setCurrentAd({ ...ad, position, index });

    // Bu reklam gösterim turu için sabit session_id üret (yalnızca turun ilk reklamında).
    if (index === 0 || !adSessionIdRef.current) {
      adSessionIdRef.current = generateAdSessionId();
    }
    const sessionId = adSessionIdRef.current;
    adViewCompleteSentRef.current = false;
    adViewStartSentRef.current = false;

    // Reklam ekrana geldi → impression event (eski "log" çağrısının yerine).
    sendAdEvent("impression", ad, sessionId);

    setAdModalOpen(true);

    // Yeni API alanları:
    //  - ad_showing_time_sec: reklamın toplam gösterim süresi (image için otomatik kapanma).
    //  - skip_button_active_sec: skip/closable butonunun kaç sn sonra aktifleşeceği.
    const mediaType = ad.media_type || "video";
    const adShowingTime = typeof ad.ad_showing_time_sec === "number" ? ad.ad_showing_time_sec : 5;
    const skipActiveSec = typeof ad.skip_button_active_sec === "number"
      ? ad.skip_button_active_sec
      : adShowingTime;

    setAdShowingTime(adShowingTime);
    setAdSkipActiveSec(skipActiveSec);

    // adTotalTime = timer pill'inin geri sayacağı süre. ads.js davranışı (runTimer):
    //  - ZORUNLU image: timer adShowingTime boyunca geri sayar (skip butonu çıkmaz;
    //    süre bitince image effect goToNextOrClose ile kapat butonunu/geçişi yönetir).
    //  - OPSİYONEL image: timer skipActiveSec geri sayar; bitince skip butonu çıkar.
    //  - ZORUNLU video: video bitene kadar buton çıkmaz → total = 0 (onEnded'de açılır,
    //    süreyi onLoadedMetadata videonun uzunluğuna set eder).
    //  - OPSİYONEL video: timer skipActiveSec geri sayar; bitince skip butonu çıkar.
    let total = 0;
    if (mediaType === "image") {
      total = ad.mandatory ? adShowingTime : skipActiveSec;
    } else if (mediaType === "video") {
      total = ad.mandatory ? 0 : skipActiveSec;
    }
    setAdTotalTime(total);
    setAdTimer(0);

    // skipActiveSec === 0 olan opsiyonel görseller direkt geçilebilir.
    if (mediaType === "image" && !ad.mandatory && skipActiveSec === 0) {
      setAdClosable(true);
    } else {
      setAdClosable(false);
    }
    if (mediaType === "video") setAdMuted(true);
  };
  // AD SYSTEM TIMER EFFECT
  // Timer pill'i adTotalTime boyunca geri sayar. Süre bitince skip/kapat butonunu
  // (adClosable) gösterir — ANCAK zorunlu image'de göstermez: orada skip butonu yok,
  // kapatma/geçiş image effect'in goToNextOrClose mantığıyla yönetilir (ads.js davranışı).
  const isMandatoryImage = !!currentAd && (currentAd.media_type || "video") === "image" && currentAd.mandatory;
  useEffect(() => {
    if (!adModalOpen || adTotalTime === 0) return;
    if (adTimer >= adTotalTime) {
      if (!isMandatoryImage) setAdClosable(true);
      return;
    }
    const interval = setInterval(() => {
      setAdTimer(prev => {
        if (prev + 1 >= adTotalTime) {
          clearInterval(interval);
          if (!isMandatoryImage) setAdClosable(true);
          return adTotalTime;
        }
        return prev + 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [adModalOpen, adTotalTime, adTimer, isMandatoryImage]);

  // IMAGE REKLAM ZAMANLAYICI EFFECT'İ — ads.js davranışını birebir uygular.
  // Bu pozisyondaki sıradaki reklam var mı yardımcı: showNextAd ile aynı listeyi kullanır.
  useEffect(() => {
    if (!adModalOpen || !currentAd) return;
    if ((currentAd.media_type || "video") !== "image") return;

    let totalAds = 0;
    if (currentAd.position === "oyun_basinda") totalAds = adsStart.length;
    else if (currentAd.position === "oyun_esnasinda") totalAds = adsInGame.length;
    else if (currentAd.position === "oyun_sonunda") totalAds = adsEnd.length;
    const hasNext = (currentAd.index ?? 0) + 1 < totalAds;

    const showTime = adShowingTime > 0 ? adShowingTime : 5;
    const skipSec = adSkipActiveSec > 0 ? adSkipActiveSec : showTime;
    const timers = [];

    if (currentAd.mandatory) {
      // ZORUNLU image (ads.js): skip butonu hiç çıkmaz. ad_showing_time_sec sonunda
      // goToNextOrClose → sıradaki varsa geç, son/tek reklamsa kapat butonunu göster.
      timers.push(setTimeout(() => {
        if (hasNext) showNextAd();
        else setAdClosable(true);
      }, showTime * 1000));
    } else {
      // OPSİYONEL image (ads.js): skip_button_active_sec sonunda skip butonu görünür
      // (bunu AD SYSTEM TIMER EFFECT yapar). Ardından ad_showing_time_sec - skip_button_active_sec
      // kadar bekleyip, SADECE sıradaki reklam varsa otomatik ona geç. Son reklamsa
      // otomatik geçiş yok; kullanıcı skip'e basarak kapatır.
      const remainingSec = Math.max(0, showTime - skipSec);
      if (remainingSec > 0 && hasNext) {
        timers.push(setTimeout(() => {
          showNextAd();
        }, showTime * 1000));
      }
    }

    return () => timers.forEach(clearTimeout);
    // currentAd değiştiğinde (yeni reklam) timer'lar sıfırlanır.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adModalOpen, currentAd, adShowingTime, adSkipActiveSec, adsStart.length, adsInGame.length, adsEnd.length]);

  const showNextAd = () => {
    if (!currentAd) return;
    // Mevcut reklamın izlenmesi tamamlandı → view_complete event (idempotent).
    if (!adViewCompleteSentRef.current) {
      adViewCompleteSentRef.current = true;
      sendAdEvent("view_complete", currentAd, adSessionIdRef.current);
    }
    let adsList = [];
    if (currentAd.position === "oyun_basinda") adsList = adsStart;
    else if (currentAd.position === "oyun_esnasinda") adsList = adsInGame;
    else if (currentAd.position === "oyun_sonunda") adsList = adsEnd;
    const nextIndex = (currentAd.index ?? 0) + 1;
    if (adsList.length > nextIndex) {
      showAd(adsList[nextIndex], currentAd.position, nextIndex);
    } else {
      // Tur bitti → bu reklam oturumunu kapat, session_id'yi sıfırla.
      adSessionIdRef.current = null;
      const finishedPosition = currentAd.position;
      setAdModalOpen(false);
      setCurrentAd(null);
      // Eğer oyun başında reklam ise, quiz ekranına geçişi burada yap
      if (finishedPosition === "oyun_basinda") {
        setScreen("quiz");
      }
      // Eğer oyun esnasında reklamlar bittiyse ve bekleyen soru varsa, sonraki soruyu çek
      if (finishedPosition === "oyun_esnasinda" && pendingNextQuestion) {
        fetchNextQuestion();
      }
    }
  };
  // --- AD SYSTEM BİTİŞ ---

  // --- BACKGROUND MUSIC SETUP ---
  const [musicInitialized, setMusicInitialized] = useState(false);

  useEffect(() => {
    // Müzik dosyasını oluştur ve ayarla
    if (!backgroundMusicRef.current) {
      backgroundMusicRef.current = new Audio(BackgroundMusic);
      backgroundMusicRef.current.loop = true;
      backgroundMusicRef.current.volume = 0.3; // Ses seviyesini ayarla
    }

    const music = backgroundMusicRef.current;

    // Component unmount olduğunda müziği temizle
    return () => {
      if (music) {
        music.pause();
        music.currentTime = 0;
      }
    };
  }, []);

  // Müziği başlatma fonksiyonu
  const initializeMusic = async () => {
    if (backgroundMusicRef.current && soundOpen && !musicInitialized) {
      try {
        await backgroundMusicRef.current.play();
        setMusicInitialized(true);
        console.log("Müzik başarıyla başlatıldı");
      } catch (error) {
        console.log("Müzik başlatılamadı:", error);
      }
    }
  };

  // Sound button kontrolü
  useEffect(() => {
    if (backgroundMusicRef.current && musicInitialized) {
      if (soundOpen && !adModalOpen) {
        backgroundMusicRef.current.play().catch(() => { });
      } else {
        backgroundMusicRef.current.pause();
      }
    }
  }, [soundOpen, adModalOpen, musicInitialized]);

  // Reklam durumunda müziği kontrol et
  useEffect(() => {
    if (backgroundMusicRef.current && musicInitialized) {
      if (adModalOpen) {
        backgroundMusicRef.current.pause();
      } else if (soundOpen) {
        backgroundMusicRef.current.play().catch(() => { });
      }
    }
  }, [adModalOpen, soundOpen, musicInitialized]);

  // Configurable values (can be changed through panels)
  const [totalTime, setTotalTime] = useState(60);

  // Fetch questions from API
  useEffect(() => {
    if (screen !== "quiz") return;
    if (!token || isTokenInvalid) return;
    if (token && !isInitialRefreshDone) return;

    fetchWithRefresh(`${baseUrl}/trivia-progress/start`, {
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    }, { globalVars: { Token: accessToken } })
      .then(async response => {
        if (!response.ok) {
          const errorData = await response.json();
          const error = new Error(errorData.detail || "Sunucu hatası");
          error.response = response;
          throw error;
        }
        return response.json();
      })
      .then(data => {
        // PATCH: if completed, show result and set score, loading, etc.
        if (data.completed === true) {
          setScore(data.current_score || 0);
          setShowResult(true);
          setLoading(false);
          setCorrectAnswerId(null);
          setAnswered(false);        // ekle
          setSelectedAnswer(null);   // ekle
          setQuestions([]);          // ekle
          return;
        }

        if (!data || !data.question || !data.answers) {
          setErrorMessage("Bir hata oluştu");
          return;
        }

        const tpq = Number(data.time_per_question);
        setTotalTime(Number.isFinite(tpq) && tpq > 0 ? Math.ceil(tpq) : 60);

        const formattedQuestion = {
          id: data.question_id,
          question: data.question,
          options: data.answers,
          correct_answer: data.correct_answer_id || null,
          question_number: data.question_number,
        };

        setQuestions([formattedQuestion]);
        setCurrentQuestionIndex(0);
        setScore(data.current_score || 0);
        setLoading(false);
        setCorrectAnswerId(null);
      })
      .catch(async error => {
        console.error("Error fetching questions from API:", error);
        let errorMsg = "Bir hata oluştu";

        // 401 veya 403 hatalarında "Geçersiz Token" mesajı göster
        if (error?.response?.status === 401 || error?.response?.status === 403) {
          errorMsg = "Geçersiz Token";
        } else if (error instanceof Error && error.message && error.message !== "Failed to fetch") {
          errorMsg = error.message;
        } else if (error?.response) {
          try {
            const res = await error.response.json();
            errorMsg = res?.message || "Bir hata oluştu";
          } catch (_) {
            // Ignore JSON parse error
          }
        }

        setErrorMessage(errorMsg);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screen, token, baseUrl, isTokenInvalid, accessToken, isInitialRefreshDone]);

  const currentQuestion = questions.length > 0 ? questions[currentQuestionIndex] : null;

  // Timer effect
  useEffect(() => {
    if (screen !== "quiz") return;
    // Sayaç sadece reklam modalı açık DEĞİLSE ve paused DEĞİLSE çalışmalı
    if (!loading && questions.length > 0 && !answered && !showResult && !adModalOpen && !paused) {
      const interval = setInterval(() => {
        if (timer < totalTime) {
          setTimer(timer + 1);
        } else {
          clearInterval(interval);
          setTimerExpired(true);
          setAnswered(true);
          setIsAnswerLoading(false);
          setShowResult(true);
          if (adsEnd.length > 0 && !adModalOpen && !currentAd) {
            tryShowAd(adsEnd, "oyun_sonunda");
          }
        }
      }, 1000);
      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screen, timer, answered, showResult, loading, questions.length, baseUrl, currentQuestion, token, score, setErrorMessage, adModalOpen, paused, totalTime]);

  // Eğer errorMessage varsa, tüm ekranı sadece hata mesajıyla göster (return ile):
  if (errorMessage) {
    return (
      <div className="quiz-container">
        <div className="loading">{errorMessage}</div>
      </div>
    );
  }

  // Lobby ekranı için check isteği sırasında yükleniyor göster
  if (screen === "lobby" && isChecking) {
    return (
      <div className="quiz-container">
        <div className="loading">Yükleniyor...</div>
      </div>
    );
  }

  // If loading or no questions, show loading state
  if (screen === "quiz" && !showResult && (loading || questions.length === 0)) {
    return (
      <div className="quiz-container">
        <div className="loading">Sorular yükleniyor...</div>
      </div>
    );
  }

  // Eğer initial refresh bitmeden ve token varken, UI'yi blokla
  if (token && !isInitialRefreshDone) {
    return (
      <div className="quiz-container" style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", width: "100%" }}>
        <div className="loading" style={{ color: "#d40000" }}>Yükleniyor...</div>
      </div>
    );
  }

  // Trivia event endpointine event gönderimi
  const sendTriviaEvent = async ({ event_name, trivia_id, token, baseUrl, session_id }) => {
    try {
      await fetchWithRefresh(
        `${baseUrl}/trivia/event`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`
          },
          body: JSON.stringify({
            trivia_id,
            event_name,
            session_id
          })
        },
        { globalVars: { Token: accessToken } }
      );
    } catch (e) {
      // Sessiz geç
    }
  };

  // Sonraki soruyu çekmek için yardımcı fonksiyon
  const fetchNextQuestion = () => {
    fetchWithRefresh(
      `${baseUrl}/trivia-progress/start`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      },
      { globalVars: { Token: accessToken } }
    )
      .then(res => res.json())
      .then(next => {
        setScore(next.current_score || score);
        const nextTpq = Number(next.time_per_question);
        setTotalTime(Number.isFinite(nextTpq) && nextTpq > 0 ? Math.ceil(nextTpq) : 60);
        const nextQuestion = {
          id: next.question_id,
          question: next.question,
          options: next.answers,
          correct_answer: null,
          question_number: next.question_number,
          current_score: next.current_score || score,
        };
        setQuestions([nextQuestion]);
        setCurrentQuestionIndex(0);
        setAnswered(false);
        setSelectedAnswer(null);
        setTimer(0);
        setTimerExpired(false);
        setLoading(false);
        setCorrectAnswerId(null);
        setIsCorrectAnswer(null);
        setPendingNextQuestion(false);
      })
      .catch(err => {
        console.error("Error fetching next question:", err);
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          setErrorMessage("Geçersiz Token");
        } else {
          setErrorMessage("Bir hata oluştu");
        }
        setPendingNextQuestion(false);
      });
  };

  const handleAnswerSelect = (answerId) => {
    setSelectedAnswer(answerId);
    setAnswered(true);
    setIsAnswerLoading(true);

    const currentQuestionId = currentQuestion.id;
    const selectedAnswerId = answerId;

    fetchWithRefresh(
      `${baseUrl}/trivia-progress/answer?question_id=${currentQuestionId}&selected_answer_id=${selectedAnswerId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      },
      { globalVars: { Token: accessToken } }
    )
      .then(res => res.json())
      .then(data => {
        setScore(data.current_score || score);
        setIsCorrectAnswer(data.correct);

        const updatedQuestion = {
          ...currentQuestion,
          correct_answer: data.correct_answer_id || null,
          // Removed current_score as per instructions
        };
        setQuestions([updatedQuestion]);
        setCorrectAnswerId(data.correct_answer_id || null);
        if (!data.correct && data.correct_answer_id) {
          setCorrectAnswerId(data.correct_answer_id);
        }
        setIsAnswerLoading(false);

        setTimeout(() => {
          if (!data.completed) {
            // 5. soru sonunda reklam göster (pozisyon başına yalnızca bir kez).
            const currentQuestionNumber = currentQuestion?.question_number;
            let adShown = false;
            if (currentQuestionNumber === 5 && !adModalOpen && !currentAd) {
              // Önce bekleme bayrağını kur, sonra reklamı dene; reklam açıldıysa
              // sonraki soru reklam kapanınca çekilir (showNextAd içinde).
              setPendingNextQuestion(true);
              adShown = tryShowAd(adsInGame, "oyun_esnasinda");
              if (!adShown) setPendingNextQuestion(false);
            }
            if (!adShown) {
              // Reklam gösterilmedi (zaten gösterilmiş/yok) → hemen sonraki soruyu çek.
              fetchNextQuestion();
            }
          } else {
            setShowResult(true);
            if (adsEnd.length > 0 && !adModalOpen && !currentAd) {
              tryShowAd(adsEnd, "oyun_sonunda");
            }
          }
        }, 2000);
      })
      .catch(err => {
        console.error("Answer submission error:", err);
        if (err?.response?.status === 401 || err?.response?.status === 403) {
          setErrorMessage("Geçersiz Token");
        } else {
          setErrorMessage("Bir hata oluştu");
        }
        setIsAnswerLoading(false);
      });
  };


  const getButtonStyle = (optionId) => {
    if (!answered) return "";
    if (optionId === selectedAnswer) {
      if (isAnswerLoading) return "load";
      return isCorrectAnswer ? "correct" : "incorrect";
    }
    if (!isCorrectAnswer && optionId === correctAnswerId) {
      return "correct";
    }
    return "";
  };

  // Calculate the circle progress (reversed)
  const calculateProgressCircle = () => {
    // Calculate percentage remaining (starts at 100%, goes to 0%)
    const remainingPercentage = 100 - (timer / totalTime) * 100;
    const circumference = 2 * Math.PI * 24; // radius is 24px

    return {
      strokeDasharray: `${circumference}`,
      strokeDashoffset: `${circumference - (remainingPercentage / 100) * circumference}`,
    };
  };

  const progressStyle = calculateProgressCircle();


  // Determine background based on question content
  let currentBackground = BG1; // Default background for normal questions
  if (currentQuestion && typeof currentQuestion.question === "string") {
    const lowerText = currentQuestion.question.toLowerCase();
    if (lowerText.includes("sprite")) {
      currentBackground = BG3;         // Sprite‑related question
    } else if (lowerText.includes("fanta")) {
      currentBackground = BG2;         // Fanta‑related question
    }
  }



  return (
    <div className="quiz-container" style={{ backgroundImage: `url(${currentBackground})` }}>
      {leaderboardOpen && (
        <div className="modal-overlay" onClick={() => setLeaderboardOpen(false)}>
          <div className="modal-content leaderboard-modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setLeaderboardOpen(false)}>
              <img src={CloseRedButton} alt="Kapat" className="modal-close-img" />
            </button>
            <iframe
              src={leaderboardUrl}
              title="Leaderboard"
              frameBorder="0"
              className="leaderboard-iframe"
            />
          </div>
        </div>
      )}
      {adModalOpen && currentAd && (
        <div className="ad-modal-overlay">
          <div className="ad-modal-content" style={{ position: "relative" }}>
            {/* AD SOUND ICON BUTTON — ads.js'teki inline hoparlör SVG'leri (pill stil) */}
            {currentAd.media_type === "video" && (
              <div className="ad-top-bar">
                <button
                  className="ad-pill-btn ad-btn-visible ad-sound-icon-btn"
                  onClick={() => {
                    setAdMuted(m => {
                      const newMuted = !m;
                      if (adVideoRef.current) {
                        adVideoRef.current.muted = newMuted;
                        if (!newMuted) adVideoRef.current.volume = 1;
                      }
                      return newMuted;
                    });
                  }}
                >
                  {adMuted ? (
                    <svg viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.75 7.75C16.3478 8.14922 16.75 8.89539 16.75 9.75C16.75 10.1082 16.6793 10.4474 16.5532 10.75M16.75 3.75C18.5434 4.94765 19.75 7.18616 19.75 9.75C19.75 10.8247 19.538 11.8423 19.1596 12.75C19.0134 13.1008 18.8423 13.4351 18.649 13.75M12.75 11.75V13.4417C12.75 15.5999 12.75 16.6791 12.4832 17.1424C11.9561 18.0579 10.8079 18.4056 9.86144 17.9362C9.38246 17.6987 8.78386 16.8008 7.58667 15.005C7.35011 14.6502 7.23183 14.4727 7.08865 14.3306C6.81197 14.056 6.46106 13.8681 6.07906 13.7903C5.88138 13.75 5.66814 13.75 5.24167 13.75H3.95C2.82989 13.75 2.26984 13.75 1.84202 13.532C1.46569 13.3403 1.15973 13.0343 0.967987 12.658C0.75 12.2302 0.75 11.6701 0.75 10.55V8.95C0.75 7.82989 0.75 7.26984 0.967987 6.84202C1.15973 6.46569 1.46569 6.15973 1.84202 5.96799C2.26984 5.75 2.8296 5.75 3.94911 5.75C4.20189 5.75 4.46894 5.75 4.75 5.75H5.24167C5.66814 5.75 5.88138 5.75 6.07906 5.70971C6.24306 5.67628 6.40133 5.62259 6.55046 5.55046M12.75 11.75L6.55046 5.55046M12.75 11.75L19.75 18.75M1.75 0.75L6.55046 5.55046M8.42267 3.25C9.09331 2.26894 9.50964 1.73824 9.86144 1.56378C10.8079 1.09443 11.9561 1.44209 12.4832 2.35759C12.75 2.82091 12.75 3.90005 12.75 6.05832V7.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  ) : (
                    <svg viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.75 7.14453C16.3478 7.54375 16.75 8.28992 16.75 9.14453C16.75 9.99915 16.3478 10.7453 15.75 11.1445M16.75 3.14453C18.5434 4.34218 19.75 6.58069 19.75 9.14453C19.75 11.7084 18.5434 13.9469 16.75 15.1445M7.58667 3.88953C7.35011 4.24437 7.23183 4.42179 7.08865 4.56392C6.81197 4.83858 6.46106 5.02638 6.07906 5.10424C5.88138 5.14453 5.66814 5.14453 5.24167 5.14453H3.95C2.82989 5.14453 2.26984 5.14453 1.84202 5.36252C1.46569 5.55426 1.15973 5.86023 0.967987 6.23655C0.75 6.66437 0.75 7.22443 0.75 8.34453V9.94453C0.75 11.0646 0.75 11.6247 0.967987 12.0525C1.15973 12.4288 1.46569 12.7348 1.84202 12.9265C2.26984 13.1445 2.8299 13.1445 3.95 13.1445H5.24167C5.66814 13.1445 5.88138 13.1445 6.07906 13.1848C6.46106 13.2627 6.81197 13.4505 7.08865 13.7251C7.23183 13.8673 7.35011 14.0447 7.58667 14.3995C8.78387 16.1953 9.38246 17.0932 9.86144 17.3308C10.8079 17.8001 11.9561 17.4524 12.4832 16.5369C12.75 16.0736 12.75 14.9945 12.75 12.8362V5.45286C12.75 3.29458 12.75 2.21544 12.4832 1.75212C11.9561 0.836622 10.8079 0.488965 9.86144 0.958307C9.38246 1.19584 8.78387 2.09373 7.58667 3.88953Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  )}
                  <span>{adMuted ? "Sesi Aç" : "Sesi Kapat"}</span>
                </button>
              </div>
            )}
            {/* Timer + Skip/Close: sağ üst (ads.js pill tasarımı) */}
            <div className="ad-top-right">
              {adTotalTime > 0 && !adClosable && (
                <div className="ad-timer-pill ad-btn-visible">
                  <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
                    <circle
                      cx="18"
                      cy="18"
                      r="15.9"
                      strokeDasharray="100"
                      strokeDashoffset={adTotalTime === 0 ? 0 : 100 * (1 - (adTotalTime - adTimer) / adTotalTime)}
                    />
                  </svg>
                  <span className="ad-timer-pill-text">{adTotalTime - adTimer}</span>
                </div>
              )}
              {adClosable && (
                currentAd && !currentAd.mandatory ? (
                  <button
                    className="ad-pill-btn ad-btn-visible"
                    onClick={() => {
                      // Opsiyonel reklamı geç → skip event, sonraki reklama/kapanışa geç.
                      sendAdEvent("skip", currentAd, adSessionIdRef.current);
                      showNextAd();
                    }}
                  >
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21 5V19M13.8128 14.6918L8.93042 17.8304C7.3245 18.8628 6.52153 19.379 5.85752 19.3316C5.27885 19.2903 4.74665 18.9997 4.39897 18.5353C4 18.0024 4 17.0478 4 15.1387V8.86133C4 6.95219 4 5.99762 4.39897 5.46471C4.74665 5.0003 5.27885 4.70974 5.85752 4.66841C6.52153 4.62099 7.3245 5.13718 8.93043 6.16956L13.8128 9.30823C15.2063 10.2041 15.9031 10.652 16.1438 11.2216C16.3541 11.7192 16.3541 12.2808 16.1438 12.7784C15.9031 13.348 15.2063 13.7959 13.8128 14.6918Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    Reklamı Geç
                  </button>
                ) : (
                  <button
                    className="ad-pill-btn ad-btn-visible"
                    onClick={() => {
                      // Zorunlu reklam tamamlandı → kapat (skip event yok).
                      showNextAd();
                    }}
                  >
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    Kapat
                  </button>
                )
              )}
            </div>
            {currentAd.media_type === "image" ? (
              <img src={currentAd.media_url} alt="Ad" className="ad-media" />
            ) : (
              <>
                <video
                  ref={adVideoRef}
                  src={currentAd.media_url}
                  controls={false}
                  autoPlay
                  muted={adMuted}
                  playsInline
                  webkit-playsinline="true"
                  onPlay={() => {
                    // Video oynamaya başladı → view_start event (idempotent, reklam başına bir kez).
                    if (!adViewStartSentRef.current) {
                      adViewStartSentRef.current = true;
                      sendAdEvent("view_start", currentAd, adSessionIdRef.current);
                    }
                  }}
                  onEnded={() => {
                    // Video bitti → view_complete event (idempotent).
                    if (!adViewCompleteSentRef.current) {
                      adViewCompleteSentRef.current = true;
                      sendAdEvent("view_complete", currentAd, adSessionIdRef.current);
                    }
                    // Birden fazla reklam varsa otomatik sıradakine geç (script davranışı).
                    let totalAds = 0;
                    if (currentAd.position === "oyun_basinda") totalAds = adsStart.length;
                    else if (currentAd.position === "oyun_esnasinda") totalAds = adsInGame.length;
                    else if (currentAd.position === "oyun_sonunda") totalAds = adsEnd.length;
                    const isLast = (currentAd.index ?? 0) + 1 >= totalAds;
                    if (!isLast) {
                      // Sıradaki reklama geç (skip event'i değil, doğal bitiş).
                      showNextAd();
                    } else {
                      // Son reklam: kapat/geç butonu görünür olsun.
                      setAdClosable(true);
                    }
                  }}
                  className="ad-media"
                  onLoadedMetadata={e => {
                    // Zorunlu videoda sayaç videonun uzunluğu kadar olacak
                    if (currentAd.media_type === "video" && currentAd.mandatory) {
                      setAdTotalTime(Math.ceil(e.target.duration));
                      setAdTimer(0);
                    }
                  }}
                />
                {/* Progress bar SADECE video reklamlarda görünür (image'de hiç render edilmez). */}
                {(currentAd.media_type || "video") === "video" && (
                  <div
                    className="ad-video-progress-bar"
                    style={{
                      width: `${videoProgressPercent}%`
                    }}
                  />
                )}
              </>
            )}
            <div className="ad-counter ad-index-info">
              {(() => {
                let totalAds = 0;
                if (currentAd.position === "oyun_basinda") totalAds = adsStart.length;
                else if (currentAd.position === "oyun_esnasinda") totalAds = adsInGame.length;
                else if (currentAd.position === "oyun_sonunda") totalAds = adsEnd.length;
                // Index etiketi yalnızca pozisyonda 1'den fazla reklam varsa gösterilir.
                const indexText = totalAds > 1 ? `${(currentAd.index ?? 0) + 1} / ${totalAds}` : "";
                const durationText =
                  currentAd.media_type === "video" && adVideoRef.current
                    ? (() => {
                      const video = adVideoRef.current;
                      const remaining = Math.floor((video.duration || 0) - video.currentTime);
                      const minutes = Math.floor(remaining / 60);
                      const seconds = remaining % 60;
                      return `${minutes}:${seconds.toString().padStart(2, "0")}`;
                    })()
                    : "";
                // İkisi de varsa araya ayıraç koy; biri boşsa sadece dolu olanı göster.
                return [indexText, durationText].filter(Boolean).join(" • ");
              })()}
            </div>
          </div>
          {/* DEEPLINK BUTONU — ads.js: kartın altında, button_* alanlarıyla stillenir.
              button_alignment (left/center/right) butonun yatay hizasını belirler. */}
          {currentAd.deeplink_enabled && (
            <div
              className="ad-deeplink-wrap"
              style={{
                justifyContent: ({ left: "flex-start", center: "center", right: "flex-end" }[currentAd.button_alignment] || "center"),
              }}
            >
              <button
                className="ad-deeplink-btn"
                style={{
                  color: currentAd.button_font_color || "#ffffff",
                  background: currentAd.button_bg_color || "#0085FF",
                  fontSize: `clamp(13px, ${typeof currentAd.button_font_size === "number" ? currentAd.button_font_size : 16}px, 18px)`,
                  borderRadius: typeof currentAd.button_corner_radius === "number" ? `${currentAd.button_corner_radius}px` : "999px",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeeplinkClick(currentAd, adSessionIdRef.current);
                }}
              >
                {currentAd.button_text || "Devam Et"}
              </button>
            </div>
          )}
        </div>
      )}
      {infoOpen && (
        <div className="modal-overlay" onClick={() => setInfoOpen(false)}>
          <div
            className="modal-content modal-border-card"
            onClick={e => e.stopPropagation()}
          >
            <button
              className="modal-close"
              onClick={() => setInfoOpen(false)}
            >
              <img src={CloseRedButton} alt="Kapat" className="modal-close-img" />
            </button>
            <div
              className="modal-inner-content"
            >
              <h2 className="modal-title">Nasıl Oynanır</h2>
              <ul className="modal-info-list">
                <li>Soruları doğru cevapla, puanları kazan, her doğru cevap 10 puan!</li>
                <li>Süren sınırlı, hızlı düşün!</li>
              </ul>
              <div className="powered-by-container">
                <img src={PoweredByZuzzuu} alt="Powered by Zuzzuu" className="powered-by-logo" />
              </div>
            </div>
          </div>
        </div>
      )}
      {screen === "lobby" ? (
        <div className="lobby-container">
          <div className="buttons-container">
            <button className="info-button" onClick={() => {
              if (!musicInitialized) initializeMusic();
              goBack(true);
            }}>
              <img src={GoBack} alt="Bilgi" />
            </button>
            <button className="sound-button" onClick={() => {
              setSoundOpen(prev => {
                const newSoundOpen = !prev;
                if (newSoundOpen && !musicInitialized) {
                  initializeMusic();
                }
                return newSoundOpen;
              });
            }}>
              {soundOpen ? (
                <img src={SoundOnButton} alt="Ses Açık" />
              ) : (
                <img src={SoundOffButton} alt="Ses Kapalı" />
              )}
            </button>
          </div>
          <div className="buttons-container">
            <button className="leaderboard-button" onClick={() => {
              if (!musicInitialized) initializeMusic();
              openLeaderboard();
            }}>
              <img src={LeaderboardButton} alt="Bilgi" />
            </button>
          </div>
          <img src={BilgiYarismasiLogo} alt="Bilgi Yarışması Logo" className="home-logo" />
          <button
            className="start-button"
            onClick={async () => {
              // Initial refresh tamamlanmadan API çağrısı yapma
              if (token && !isInitialRefreshDone) {
                setLoading(true);
                return;
              }
              // Müziği başlat
              if (!musicInitialized) await initializeMusic();

              // Reset all relevant gameplay state to ensure clean start before starting quiz
              setScore(0);
              setShowResult(false);
              setAnswered(false);
              setSelectedAnswer(null);
              setQuestions([]);
              setTimer(0);
              setTimerExpired(false);
              setLoading(true);
              setCorrectAnswerId(null);
              setIsCorrectAnswer(null);
              setIsAnswerLoading(false);
              // Eğer başta reklam varsa (ve bu oturumda daha önce gösterilmediyse) önce
              // reklamı göster; quiz ekranına reklam bitince geçilecek.
              if (tryShowAd(adsStart, "oyun_basinda")) {
                return; // reklam bitince screen değişimi (showNextAd içinde) yapılacak
              }
              try {
                const response = await fetchWithRefresh(
                  `${baseUrl}/trivia-progress/start`,
                  {
                    headers: {
                      Authorization: `Bearer ${accessToken}`
                    }
                  },
                  { globalVars: { Token: accessToken } }
                );
                const data = await response.json();
                if (data.completed === true) {
                  setScore(data.current_score || 0);
                  setShowResult(true);
                  // State already reset above
                  setScreen("quiz");
                  return;
                }
                sendTriviaEvent({ event_name: "oyun_basladi", trivia_id: triviaId, token, baseUrl, session_id: sessionId });
                setScreen("quiz");
              } catch {
                setErrorMessage("Başlatılamadı, tekrar deneyin.");
              }
            }}>
            <img src={StartButton} alt="Başla" />
          </button>
          <button className="info-button" onClick={() => {
            if (!musicInitialized) initializeMusic();
            setInfoOpen(true);
          }}>
            <img src={InfoButton} alt="Bilgi" />
          </button>
          <div className="version-info">v1.0.0.2</div>
        </div>
      ) : (
        <>
          {/* Aşağıdaki mevcut quiz kodunun tamamını buraya al */}
          {showResult ? (
            <div className="modal-overlay" onClick={() => {
              if (!musicInitialized) initializeMusic();
              setShowResult(false);
              setScreen("lobby");
              if (adsEnd.length > 0 && !adModalOpen && !currentAd) {
                tryShowAd(adsEnd, "oyun_sonunda");
              }
            }}>
              <div
                className="modal-content modal-border-card"
                onClick={e => e.stopPropagation()}
              >
                <button
                  className="modal-close"
                  onClick={() => {
                    if (!musicInitialized) initializeMusic();
                    setShowResult(false);
                    setScreen("lobby");
                    if (adsEnd.length > 0 && !adModalOpen && !currentAd) {
                      tryShowAd(adsEnd, "oyun_sonunda");
                    }
                  }}
                >
                  <img src={CloseRedButton} alt="Kapat" className="modal-close-img" />
                </button>
                <div className="modal-inner-content">
                  <h2 className="modal-title">{score === 0 ? "ÜZGÜNÜZ ☹️" : "SORULARI TAMAMLADINIZ 😊"}</h2>
                  <p className="score-text">Puanınız</p>
                  <p className="score-result">{score}</p>
                </div>
              </div>
            </div>
          ) : (
            <>
              <div className="header-container">
                <div className="header-buttons">
                  <button className="exit-button" onClick={() => {
                    if (!musicInitialized) initializeMusic();
                    setPaused(false);
                    setShowResult(false);
                    setScreen("lobby");
                    if (adsEnd.length > 0 && !adModalOpen && !currentAd) {
                      tryShowAd(adsEnd, "oyun_sonunda");
                    }
                  }}>
                    <img src={GoBack} alt="Ana Sayfa" />
                  </button>
                </div>
                {!timerExpired && (
                  <div className="timer-container">
                    <div className="circular-timer">
                      <svg className="timer-svg" viewBox="0 0 56 56">
                        <circle className="timer-background" cx="28" cy="28" r="24" />
                        <circle
                          className="timer-progress"
                          cx="28" cy="28" r="24"
                          style={progressStyle}
                        />
                      </svg>
                      <div className="timer-text">{String(totalTime - timer).padStart(2, '0')}</div>
                    </div>
                  </div>
                )}
                <div className="score-container">
                  <div className="score">
                    <img src={ZCoin} alt="ZCoin" className="coin-icon" />
                    <p>{score}</p>
                  </div>
                </div>
              </div>
              <div className="content-container">
                <div className="question-content">
                  <div className="question-number">{currentQuestion?.question_number}. SORU</div>
                  <h2 className="question-text">{currentQuestion?.question}</h2>
                </div>
                <div className="options-container">
                  {currentQuestion?.options?.map((option, index) => (
                    <button
                      key={index}
                      onClick={() => !answered && handleAnswerSelect(option.id)}
                      className={`option-button ${getButtonStyle(option.id)}`}
                      disabled={answered}
                    >
                      <p className="option-text">
                        {option.answer}
                      </p>
                      {answered && (
                        <>
                          {selectedAnswer === option.id && (
                            <img
                              src={isCorrectAnswer ? TrueIcon : FalseIcon}
                              alt={isCorrectAnswer ? "Doğru" : "Yanlış"}
                              className="answer-icon"
                            />
                          )}
                          {!isCorrectAnswer && option.id === correctAnswerId && option.id !== selectedAnswer && (
                            <img
                              src={TrueIcon}
                              alt="Doğru"
                              className="answer-icon"
                            />
                          )}
                        </>
                      )}
                    </button>
                  ))}
                </div>
              </div>
            </>
          )}
          {paused && (
            <div className="modal-overlay" onClick={() => { }}>
              <div className="modal-content modal-border-card" onClick={e => e.stopPropagation()}>
                <div className="modal-inner-content">
                  <h2 className="modal-title">Duraklatıldı</h2>
                  <div className="pause-buttons">
                    <button
                      className="resume-button"
                      onClick={() => {
                        if (!musicInitialized) initializeMusic();
                        setPaused(false);
                      }}
                    >
                      <img src={StartButton} alt="Devam Et" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default App;
